const { $ } = window;

window.YP.FormOrderAdvanced = () => ({
    LAST_NAME_NATURE: '1',
    FIRST_NAME_NATURE: '2',
    EMAIL_NATURE: '6',

    init() {
        // Observe the changes in the DOM when the button is clicked
        $('#js-confirm-addsell').on('click', () => {
            this.observeFormChanges();
        });
    },

    observeFormChanges() {
        // Create a MutationObserver to observe the changes in the DOM
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Check if form elements were actually added
                    const hasFormElements = Array.from(mutation.addedNodes)
                        .some((node) => (
                            node.nodeType === Node.ELEMENT_NODE
                            && (node.matches('form') || node.querySelector('form')
                                || node.matches('input') || node.querySelector('input'))
                        ));
                    if (hasFormElements) {
                        this.handleMutation();
                        observer.disconnect();
                    }
                }
            });
        });

        // Observe the changes in the DOM
        observer.observe(document.querySelector('#addsell-form'), {
            childList: true,
            subtree: true,
        });
    },

    handleMutation() {
        try {
            // Select the input fields
            const inputLastName = $(`input[nature="${this.LAST_NAME_NATURE}"]`).first();
            const inputFirstName = $(`input[nature="${this.FIRST_NAME_NATURE}"]`).first();
            const inputEmail = $(`input[nature="${this.EMAIL_NATURE}"]`).first();

            // Add event listeners to the input fields
            if (inputLastName.length) {
                $('#addsell_last_name').on('change keyup', function handleChange() {
                    inputLastName.val($(this).val());
                });
            }
            if (inputFirstName.length) {
                $('#addsell_first_name').on('change keyup', function handleChange() {
                    inputFirstName.val($(this).val());
                });
            }
            if (inputEmail.length) {
                $('#addsell_email_address').on('change keyup', function handleChange() {
                    inputEmail.val($(this).val());
                });
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('FormOrderAdvanced: Error during initialization', error);
        }
    },
});

window.addEventListener('load', () => window.YP.FormOrderAdvanced().init());
